import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { loadUser } from 'src/app/auth/auth.actions';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { UserRoles } from 'src/app/shared/enums/roles-enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { unsetUser } from 'src/app/auth/auth.actions';
import Swal from 'sweetalert2';
import { MatSidenav } from '@angular/material/sidenav';
import { UserService } from 'src/app/dashboard/services/user.service';
import { DataUpdateRequestService } from 'src/app/dashboard/services/data-update-request.service';
import { PlatformMessagesService } from 'src/app/dashboard/services/platform-messages.service';
import { N58Service, N58Health } from 'src/app/dashboard/services/n58.service';
import { BancoPlazaService, BancoPlazaHealth } from 'src/app/dashboard/services/banco-plaza.service';
import { DenounceAdminService } from 'src/app/dashboard/services/denounce-admin.service';
import { AgentAccessService } from 'src/app/dashboard/services/agent-access.service';
import { environment } from 'src/environments/environment';
import { clearIdleAnchors } from 'src/app/shared/utils/session-age';
import { esTitularVesChileno, tieneSaldoVes } from 'src/app/shared/utils/saldo-ves';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MarkupAlertModalComponent } from './markup-alert-modal.component';
import { ReporteClienteService } from 'src/app/dashboard/services/reporte-cliente.service';
import { AsistenteClienteService } from 'src/app/dashboard/services/asistente-cliente.service';
import {
  clienteDeUsuario,
  mensajeGeneral,
} from 'src/app/dashboard/components/asistente-cliente/asistente-operador.rules';
import { LlaveService } from 'src/app/shared/services/llave.service';
import { PayerInvitationService } from 'src/app/dashboard/services/payer-invitation.service';
import { ApiExternaCuentaService } from 'src/app/shared/services/api-externa-cuenta.service';
import {
  AvisoMarkup,
  MarkupWatchService,
  REAPARICION_AVISO_MS,
} from '../../services/markup-watch.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.sass'],
})
export class NavbarComponent implements OnDestroy {
  isEnabledUser: boolean = false;
  userName: string = '';
  userName2: string = '';
  userRole: UserRoles = UserRoles.aguacate_client;
  rolesEnum = UserRoles;
  subscription: Subscription = new Subscription();
  canSeePayers: number = 0;
  tipoId: string = '';

  numeroId: string = '';

  /**
   * Menú CLP con saldo VES: familia CL y también CCVE/V o un tipo vacío con
   * cédula V/E (mismo criterio que Nest, `puedeTenerSaldoVes`). Suma la
   * sección "Bolívares". El `tipoId === 'VE'` tiene su propio menú VES.
   */
  get esChilenoConVes(): boolean {
    return this.tipoId !== 'VE' && tieneSaldoVes(this.tipoId, this.numeroId);
  }

  /** Comprar bolívares con CLP: Nest la permite solo a la familia CL. */
  get puedeComprarBolivares(): boolean {
    return esTitularVesChileno(this.tipoId);
  }

  /**
   * «Mi usuario y referidos» sólo con una campaña activa de su país. Nace en
   * `false` y lo decide el backend (`miPrograma`) cuando ya hay usuario: un
   * venezolano no ve el menú de una campaña de Chile, ni al revés.
   */
  referidosVisible = false;
  private referidosDe: string | null = null;
  /** Clave con la que se preguntó por última vez si ve pagadores. */
  private pagadoresDe: string | null = null;
  /** «API de tasas» en el menú del cliente: lo decide `api-externa-cuenta/estado`. */
  apiExternaVisible = false;
  private apiExternaDe: string | null = null;
  userId: any = '';
  unreadMessages: number = 0;
  n58Health: N58Health | null = null;
  bancoPlazaHealth: BancoPlazaHealth | null = null;
  showDenounceMenu = false;
  denounceRole: string | null = null;
  showAgentChat = false;
  /**
   * Hay una descarga de historial en curso. Deshabilita el item del sidebar.
   *
   * Lo escribe la suscripcion a `ReporteClienteService.descargando$`, nunca el
   * componente: si la descarga se dispara desde otra pantalla, el item del
   * sidebar tiene que reflejarlo igual.
   */
  descargandoHistorial = false;
  /** Panel del asistente de botones, abierto desde el botón de ayuda. */
  asistenteAbierto = false;
  /** Usuario del store, para el mensaje de WhatsApp de soporte. */
  private usuarioActual: any = null;
  /**
   * Kill-switch global del modulo binance-link en el sidebar. Por default
   * `true` en todos los ambientes — los OPERADORES lo ven en prod/qa/dev.
   *
   * IMPORTANTE: este flag NO controla la visibilidad para clientes. Los
   * clientes nunca ven nada de binance-link porque el panel del sidebar
   * esta dentro de `*ngIf="userRole === rolesEnum.aguacate_operator"` y
   * la ruta `/wallet/admin/wallets-usuarios` esta protegida por
   * `OperatorGuard`. El backend ademas exige `AguacateOperatorGuard` en
   * cada endpoint.
   *
   * Cambiar a `false` solo para deshabilitar el modulo TAMBIEN a operadores
   * en algun ambiente (kill-switch).
   */
  readonly binanceLinkEnabled: boolean = environment.binanceLinkEnabled === true;

  /** En prod "Movimientos Vita" no sale en el sidebar; se entra solo por URL. */
  readonly vitaMovimientosEnSidebar: boolean = environment.vitaMovimientosEnSidebar === true;

  get inboxRoute(): string {
    return this.userRole === this.rolesEnum.aguacate_operator
      ? '/wallet/admin/messages-inbox'
      : '/wallet/client/messages-inbox';
  }

  private cognitoEmail: string = '';
  private cognitoGroup: string = '';

  // Aviso de markup fuera de banda. Vive acá y no en la pantalla de tasas
  // porque tiene que alcanzar al operador en cualquier pantalla.
  avisoMarkup: AvisoMarkup | null = null;
  private markupDialogRef?: MatDialogRef<MarkupAlertModalComponent>;
  readonly minutosReaparicionMarkup = Math.round(REAPARICION_AVISO_MS / 60000);

  constructor(
private store: Store<AppState>,
    private auth: CognitoService,
    private spinner: SpinnerService,
    private router: Router,
    private cognitoService: CognitoService,
    private userService: UserService,
    private socketService: SocketService,
    private platformMessagesService: PlatformMessagesService,
    private n58Service: N58Service,
    private bancoPlazaService: BancoPlazaService,
    private denounceService: DenounceAdminService,
    private agentAccessService: AgentAccessService,
    private dataUpdateRequestService: DataUpdateRequestService,
    private markupWatch: MarkupWatchService,
    private dialog: MatDialog,
    private reporteCliente: ReporteClienteService,
    private asistenteCliente: AsistenteClienteService,
    private llaveService: LlaveService,
    private payerInvitations: PayerInvitationService,
    private apiExternaCuenta: ApiExternaCuentaService,
  ) {
    this.initNavbar();

    // El estado de la descarga vive en el servicio. El sidebar solo lo refleja.
    this.subscription.add(
      this.reporteCliente.descargando$.subscribe((enCurso) => {
        this.descargandoHistorial = enCurso;
      })
    );
  }

  private async initNavbar() {
    const [cognitoUser, cognitoSession] = await Promise.all([
      this.auth.getUser(),
      this.auth.getSession(),
    ]);

    if (cognitoSession) {
      this.cognitoGroup =
        cognitoSession['accessToken']['payload']['cognito:groups'][0];
      this.cognitoEmail = cognitoUser?.attributes?.['email'] || '';
      this.userRole = this.cognitoGroup as UserRoles;

      // El estado del asistente se pide ahora y no al tocar el botón: si el
      // toque tuviera que esperar al servidor, abrir WhatsApp después de ese
      // `await` lo bloquea Safari en iPhone. Nunca falla: ante un error queda
      // apagado y el botón abre WhatsApp como siempre.
      if (this.userRole === UserRoles.aguacate_client) {
        this.asistenteCliente.reiniciar();
        void this.asistenteCliente.cargarEstado();
      }

      if (this.cognitoEmail) {
        this.userName = this.cognitoEmail;
        this.userName2 = await this.generateCod(
          this.cognitoEmail.toLocaleLowerCase(),
        );
      }
    }

    // Ya no hay corte por inactividad para nadie: operadores y clientes tienen
    // el mismo tope de 12 h desde el login, que maneja SessionExpiryService.
    // Se borra el rastro que haya dejado el contador viejo en este navegador.
    clearIdleAnchors();

    this.socketService.connect();
    this.loadUnreadCount();
    this.listenPlatformMessages();
    this.pollN58Health();
    this.pollBancoPlazaHealth();
    this.vigilarMarkup();
    this.checkDenounceAccess();
    this.checkAgentAccess();

    this.subscription.add(
      this.store.select('auth').subscribe(({ user, isLogged }: any) => {
        // El menú "Pagadores" se muestra solo si el cliente está habilitado
        // (permiso + APROBADO). Lo decide el backend, no el flag del store.
        this.cargarVisibilidadPagadores(user);
        this.cargarVisibilidadApiExterna(user);
        this.usuarioActual = user ?? null;

        if (!isLogged) {
          if (this.cognitoEmail && this.cognitoGroup) {
            this.store.dispatch(
              loadUser({ email: this.cognitoEmail, role: this.cognitoGroup }),
            );
          }
          return;
        }
        if (user && Object.keys(user).length !== 0 && user !== null) {
          this.userName = `${user.nombre} ${user.apellidos}`;
          this.userId = user?.usuarioId ? ` - Id:${user.usuarioId}` : '';
          this.tipoId = user?.tipoId || '';
          this.numeroId = user?.numeroId || '';
          this.isEnabledUser = true;
          this.cargarVisibilidadReferidos(user?.email || String(user?.usuarioId || ''));
        }
      }),
    );
  }

  /**
   * Una vez por usuario: el store emite varias veces por sesión y no hace
   * falta volver a preguntar. Si cambia el usuario (otro login en la misma
   * pestaña) se vuelve a preguntar y, mientras tanto, el ítem se esconde.
   */
  private cargarVisibilidadReferidos(clave: string): void {
    if (!clave || clave === this.referidosDe) return;
    this.referidosDe = clave;
    this.referidosVisible = false;
    this.llaveService.miPrograma().then((r) => {
      if (this.referidosDe === clave) this.referidosVisible = r.visible;
    });
  }

  /**
   * Pregunta al backend si el cliente ve pagadores. Se repite solo si cambia
   * el usuario, su permiso o su estado en el store; mientras tanto, y ante
   * cualquier error, el menú queda escondido.
   */
  private cargarVisibilidadPagadores(user: any): void {
    if (this.userRole !== UserRoles.aguacate_client || !user?.usuarioId) {
      this.pagadoresDe = null;
      this.canSeePayers = 0;
      return;
    }
    const clave = `${user.usuarioId}:${user.canAddPayers ?? ''}:${user.estadoComplianceID ?? ''}`;
    if (clave === this.pagadoresDe) return;
    this.pagadoresDe = clave;
    this.canSeePayers = 0;
    this.payerInvitations
      .getAcceso()
      .then((acceso) => {
        if (this.pagadoresDe === clave) this.canSeePayers = acceso?.habilitado ? 1 : 0;
      })
      .catch(() => {
        if (this.pagadoresDe === clave) this.canSeePayers = 0;
      });
  }

  /**
   * Pregunta al backend si el cliente tiene la API de tasas habilitada. Una
   * vez por usuario (y por cambio de su estado); ante cualquier error el menú
   * queda escondido. Mismo mecanismo que el de pagadores.
   */
  private cargarVisibilidadApiExterna(user: any): void {
    if (this.userRole !== UserRoles.aguacate_client || !user?.usuarioId) {
      this.apiExternaDe = null;
      this.apiExternaVisible = false;
      return;
    }
    const clave = `${user.usuarioId}:${user.estadoComplianceID ?? ''}`;
    if (clave === this.apiExternaDe) return;
    this.apiExternaDe = clave;
    this.apiExternaVisible = false;
    this.apiExternaCuenta
      .estado()
      .then((r) => {
        if (this.apiExternaDe === clave) this.apiExternaVisible = r?.habilitado === true;
      })
      .catch(() => {
        if (this.apiExternaDe === clave) this.apiExternaVisible = false;
      });
  }

  private loadUnreadCount(): void {
    this.platformMessagesService.loadUnreadCount();
    this.subscription.add(
      this.platformMessagesService.unreadCount.subscribe(
        (count) => (this.unreadMessages = count),
      ),
    );
  }

  private listenPlatformMessages(): void {
    this.subscription.add(
      this.socketService.onPlatformMessage$().subscribe((msg) => {
        this.platformMessagesService.incrementUnread();
        this.showNotificationToast(msg);
      }),
    );
  }

  private showNotificationToast(msg: any): void {
    const bodyPreview = msg.body?.length > 80
      ? msg.body.substring(0, 80) + '...'
      : msg.body || '';

    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 6000,
      timerProgressBar: true,
      customClass: {
        popup: 'aguacate-toast',
        timerProgressBar: 'aguacate-toast-progress',
      },
      html: `
        <div style="display: flex; align-items: flex-start; gap: 12px;">
          <div style="width: 40px; height: 40px; border-radius: 10px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 1px solid #bbf7d0; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <img src="assets/img/LogoAW2025.png" style="width: 24px; height: auto;" />
          </div>
          <div style="flex: 1; min-width: 0;">
            <div style="font-size: 0.7rem; font-weight: 600; color: #1C593D; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px;">Aguacate Wallet</div>
            <div style="font-size: 0.88rem; font-weight: 700; color: #111827; margin-bottom: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${msg.subject}</div>
            <div style="font-size: 0.78rem; color: #6b7280; line-height: 1.3; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">${bodyPreview}</div>
          </div>
        </div>
      `,
    });
  }

  async generateCod(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

    return hashHex;
  }
  private pollN58Health(): void {
    if (this.userRole !== this.rolesEnum.aguacate_operator) return;
    this.subscription.add(
      this.n58Service.getHealth().subscribe({
        next: (h) => (this.n58Health = h),
        error: () => (this.n58Health = null),
      }),
    );
  }

  private pollBancoPlazaHealth(): void {
    if (this.userRole !== this.rolesEnum.aguacate_operator) return;
    this.subscription.add(
      this.bancoPlazaService.getHealth().subscribe({
        next: (h) => (this.bancoPlazaHealth = h),
        error: () => (this.bancoPlazaHealth = null),
      }),
    );
  }

  /**
   * Enciende la vigilancia del markup y traduce su estado a lo que ve el
   * operador: el modal cuando corresponde interrumpirlo, y la píldora con la
   * cuenta regresiva mientras el aviso está reconocido.
   *
   * Va después del corte por inactividad vencida, igual que los otros
   * pollings: si la sesión ya murió, no queremos salir a pedir nada.
   */
  private vigilarMarkup(): void {
    if (this.userRole !== this.rolesEnum.aguacate_operator) return;

    this.markupWatch.iniciar();
    this.subscription.add(
      this.markupWatch.aviso$.subscribe((aviso) => {
        this.avisoMarkup = aviso;

        if (aviso?.mostrarModal) {
          this.abrirModalMarkup(aviso);
        } else {
          // Volvió a la banda, o el operador lo reconoció: el modal se cierra
          // solo. No hay que dejarlo abierto mostrando un número viejo.
          this.markupDialogRef?.close();
        }
      }),
    );
  }

  private abrirModalMarkup(aviso: AvisoMarkup): void {
    // Un solo aviso a la vez: cada lectura nueva reemitiría el estado y, sin
    // esta guarda, apilaría un diálogo encima del anterior.
    if (this.markupDialogRef) return;

    this.markupDialogRef = this.dialog.open(MarkupAlertModalComponent, {
      data: {
        verificacion: aviso.verificacion,
        operador: aviso.operador,
        actualizadoEn: aviso.actualizadoEn,
        minutosParaVolver: this.minutosReaparicionMarkup,
      },
      disableClose: true,
      maxWidth: window.innerWidth < 768 ? '95vw' : '460px',
      panelClass: 'aguacate-dialog',
    });

    this.subscription.add(
      this.markupDialogRef.afterClosed().subscribe((resultado) => {
        this.markupDialogRef = undefined;
        if (resultado === 'ack') this.markupWatch.reconocer();
      }),
    );
  }

  private checkAgentAccess(): void {
    if (this.userRole !== this.rolesEnum.aguacate_operator) return;
    this.agentAccessService.checkAccess().then((hasAccess) => {
      this.showAgentChat = hasAccess;
    });
  }

  private checkDenounceAccess(): void {
    if (this.userRole !== this.rolesEnum.aguacate_operator) return;
    this.subscription.add(
      this.denounceService.checkAccess().subscribe({
        next: (res) => {
          this.showDenounceMenu = res.hasAccess;
          this.denounceRole = res.role || null;
          console.log('[Denounce] checkAccess:', res);
        },
        error: (err) => {
          console.error('[Denounce] checkAccess error:', err);
          this.showDenounceMenu = false;
          this.denounceRole = null;
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.socketService.disconnect();
    this.markupWatch.detener();
  }

  signOut() {
    Swal.fire({
      iconHtml:
        '<img src="assets/icons/question.svg" style="width: 80px; height: 80px; margin-top:20px"/>',
      customClass: {
        icon: 'no-border animate-bounce',
      },
      title: 'Cerrar sesión',
      text: '¿Está seguro que desea cerrar la sesión?',
      showCancelButton: true,
      cancelButtonText: 'No',
      showDenyButton: false,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#1e5a3f',
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.cognitoEmail = '';
        this.cognitoGroup = '';
        this.socketService.disconnect();
        this.dataUpdateRequestService.clear();
        const ref = this.spinner.start();
        try {
          // Limpia el estado del usuario en el Store
          await this.store.dispatch(unsetUser());

          // Llama al método signOut del servicio
          await this.auth.signOut();

          // Redirige al login
          this.router.navigate(['/auth/login']);
        } catch (error) {
        } finally {
          this.spinner.stop(ref);
        }
      }
    });
  }

  closeSidenav(sidenav: MatSidenav) {
    sidenav.close();
  }

  /**
   * Descarga el historial completo del cliente en Excel.
   *
   * Cierra el sidebar y suelta: el aviso lateral lo maneja el servicio, asi que
   * el cliente puede seguir navegando mientras el archivo se genera. Nada de
   * modal — bloquear la pantalla para decir "espera" es lo contrario de lo que
   * se quiere.
   *
   * El guardia del principio es el que importa: sin el, un doble click gasta
   * dos de las descargas del dia del cliente y la segunda le vuelve como 429.
   */
  descargarHistorial(sidenav: MatSidenav) {
    this.closeSidenav(sidenav);
    // `descargandoHistorial` NO se toca aca: lo maneja la suscripcion a
    // `descargando$`. Una sola fuente de verdad, en el servicio, que es
    // ademas quien puede frenar una segunda descarga simultanea venga de
    // donde venga.
    void this.reporteCliente.descargar();
  }

  get isCompanyRegistration(): boolean {
    return this.router.url.includes('company-registration');
  }

  /**
   * Botón de ayuda del cliente. Con el asistente encendido abre el panel de
   * botones; apagado, sin respuesta todavía o con error, abre WhatsApp como
   * siempre. La decisión es inmediata, sin esperar al servidor.
   */
  abrirAyuda(): void {
    if (this.asistenteCliente.activo) {
      this.asistenteAbierto = true;
      return;
    }
    this.redirectToExternalLink();
  }

  /** WhatsApp de soporte con el mensaje general, ya con nombre e ID del cliente. */
  redirectToExternalLink(): void {
    this.asistenteCliente.abrirWhatsApp(mensajeGeneral(clienteDeUsuario(this.usuarioActual)));
  }
}
